"use client";

// src/select.tsx
import _toArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _objectWithoutProperties from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeSelect", "disabled"],
  _excluded2 = ["__scopeSelect", "className", "style", "children", "placeholder"],
  _excluded3 = ["__scopeSelect", "children"],
  _excluded4 = ["__scopeSelect", "position", "onCloseAutoFocus", "onEscapeKeyDown", "onPointerDownOutside", "side", "sideOffset", "align", "alignOffset", "arrowPadding", "collisionBoundary", "collisionPadding", "sticky", "hideWhenDetached", "avoidCollisions"],
  _excluded5 = ["__scopeSelect", "onPlaced"],
  _excluded6 = ["__scopeSelect", "align", "collisionPadding"],
  _excluded7 = ["__scopeSelect", "nonce"],
  _excluded8 = ["__scopeSelect"],
  _excluded9 = ["__scopeSelect"],
  _excluded0 = ["__scopeSelect", "value", "disabled", "textValue"],
  _excluded1 = ["__scopeSelect", "className", "style"],
  _excluded10 = ["__scopeSelect"],
  _excluded11 = ["__scopeSelect", "onAutoScroll"],
  _excluded12 = ["__scopeSelect"],
  _excluded13 = ["__scopeSelect"],
  _excluded14 = ["__scopeSelect", "value"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import * as ReactDOM from "react-dom";
import { clamp } from "@radix-ui/number";
import { composeEventHandlers } from "@radix-ui/primitive";
import { createCollection } from "@radix-ui/react-collection";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { createContextScope } from "@radix-ui/react-context";
import { useDirection } from "@radix-ui/react-direction";
import { DismissableLayer } from "@radix-ui/react-dismissable-layer";
import { useFocusGuards } from "@radix-ui/react-focus-guards";
import { FocusScope } from "@radix-ui/react-focus-scope";
import { useId } from "@radix-ui/react-id";
import * as PopperPrimitive from "@radix-ui/react-popper";
import { createPopperScope } from "@radix-ui/react-popper";
import { Portal as PortalPrimitive } from "@radix-ui/react-portal";
import { Primitive } from "@radix-ui/react-primitive";
import { createSlot } from "@radix-ui/react-slot";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { useLayoutEffect } from "@radix-ui/react-use-layout-effect";
import { usePrevious } from "@radix-ui/react-use-previous";
import { VISUALLY_HIDDEN_STYLES } from "@radix-ui/react-visually-hidden";
import { hideOthers } from "aria-hidden";
import { RemoveScroll } from "react-remove-scroll";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var OPEN_KEYS = [" ", "Enter", "ArrowUp", "ArrowDown"];
var SELECTION_KEYS = [" ", "Enter"];
var SELECT_NAME = "Select";
var _createCollection = createCollection(SELECT_NAME),
  _createCollection2 = _slicedToArray(_createCollection, 3),
  Collection = _createCollection2[0],
  useCollection = _createCollection2[1],
  createCollectionScope = _createCollection2[2];
var _createContextScope = createContextScope(SELECT_NAME, [createCollectionScope, createPopperScope]),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  createSelectContext = _createContextScope2[0],
  createSelectScope = _createContextScope2[1];
var usePopperScope = createPopperScope();
var _createSelectContext = createSelectContext(SELECT_NAME),
  _createSelectContext2 = _slicedToArray(_createSelectContext, 2),
  SelectProvider = _createSelectContext2[0],
  useSelectContext = _createSelectContext2[1];
var _createSelectContext3 = createSelectContext(SELECT_NAME),
  _createSelectContext4 = _slicedToArray(_createSelectContext3, 2),
  SelectNativeOptionsProvider = _createSelectContext4[0],
  useSelectNativeOptionsContext = _createSelectContext4[1];
var Select = function Select(props) {
  var __scopeSelect = props.__scopeSelect,
    children = props.children,
    openProp = props.open,
    defaultOpen = props.defaultOpen,
    onOpenChange = props.onOpenChange,
    valueProp = props.value,
    defaultValue = props.defaultValue,
    onValueChange = props.onValueChange,
    dir = props.dir,
    name = props.name,
    autoComplete = props.autoComplete,
    disabled = props.disabled,
    required = props.required,
    form = props.form;
  var popperScope = usePopperScope(__scopeSelect);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    trigger = _React$useState2[0],
    setTrigger = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    valueNode = _React$useState4[0],
    setValueNode = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    valueNodeHasChildren = _React$useState6[0],
    setValueNodeHasChildren = _React$useState6[1];
  var direction = useDirection(dir);
  var _useControllableState = useControllableState({
      prop: openProp,
      defaultProp: defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false,
      onChange: onOpenChange,
      caller: SELECT_NAME
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    open = _useControllableState2[0],
    setOpen = _useControllableState2[1];
  var _useControllableState3 = useControllableState({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange,
      caller: SELECT_NAME
    }),
    _useControllableState4 = _slicedToArray(_useControllableState3, 2),
    value = _useControllableState4[0],
    setValue = _useControllableState4[1];
  var triggerPointerDownPosRef = React.useRef(null);
  var isFormControl = trigger ? form || !!trigger.closest("form") : true;
  var _React$useState7 = React.useState(/* @__PURE__ */new Set()),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    nativeOptionsSet = _React$useState8[0],
    setNativeOptionsSet = _React$useState8[1];
  var nativeSelectKey = Array.from(nativeOptionsSet).map(function (option) {
    return option.props.value;
  }).join(";");
  return /* @__PURE__ */jsx(PopperPrimitive.Root, _objectSpread(_objectSpread({}, popperScope), {}, {
    children: /* @__PURE__ */jsxs(SelectProvider, {
      required: required,
      scope: __scopeSelect,
      trigger: trigger,
      onTriggerChange: setTrigger,
      valueNode: valueNode,
      onValueNodeChange: setValueNode,
      valueNodeHasChildren: valueNodeHasChildren,
      onValueNodeHasChildrenChange: setValueNodeHasChildren,
      contentId: useId(),
      value: value,
      onValueChange: setValue,
      open: open,
      onOpenChange: setOpen,
      dir: direction,
      triggerPointerDownPosRef: triggerPointerDownPosRef,
      disabled: disabled,
      children: [/* @__PURE__ */jsx(Collection.Provider, {
        scope: __scopeSelect,
        children: /* @__PURE__ */jsx(SelectNativeOptionsProvider, {
          scope: props.__scopeSelect,
          onNativeOptionAdd: React.useCallback(function (option) {
            setNativeOptionsSet(function (prev) {
              return new Set(prev).add(option);
            });
          }, []),
          onNativeOptionRemove: React.useCallback(function (option) {
            setNativeOptionsSet(function (prev) {
              var optionsSet = new Set(prev);
              optionsSet.delete(option);
              return optionsSet;
            });
          }, []),
          children: children
        })
      }), isFormControl ? /* @__PURE__ */jsxs(SelectBubbleInput, {
        "aria-hidden": true,
        required: required,
        tabIndex: -1,
        name: name,
        autoComplete: autoComplete,
        value: value,
        onChange: function onChange(event) {
          return setValue(event.target.value);
        },
        disabled: disabled,
        form: form,
        children: [value === void 0 ? /* @__PURE__ */jsx("option", {
          value: ""
        }) : null, Array.from(nativeOptionsSet)]
      }, nativeSelectKey) : null]
    })
  }));
};
Select.displayName = SELECT_NAME;
var TRIGGER_NAME = "SelectTrigger";
var SelectTrigger = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    triggerProps = _objectWithoutProperties(props, _excluded);
  var popperScope = usePopperScope(__scopeSelect);
  var context = useSelectContext(TRIGGER_NAME, __scopeSelect);
  var isDisabled = context.disabled || disabled;
  var composedRefs = useComposedRefs(forwardedRef, context.onTriggerChange);
  var getItems = useCollection(__scopeSelect);
  var pointerTypeRef = React.useRef("touch");
  var _useTypeaheadSearch = useTypeaheadSearch(function (search) {
      var enabledItems = getItems().filter(function (item) {
        return !item.disabled;
      });
      var currentItem = enabledItems.find(function (item) {
        return item.value === context.value;
      });
      var nextItem = findNextItem(enabledItems, search, currentItem);
      if (nextItem !== void 0) {
        context.onValueChange(nextItem.value);
      }
    }),
    _useTypeaheadSearch2 = _slicedToArray(_useTypeaheadSearch, 3),
    searchRef = _useTypeaheadSearch2[0],
    handleTypeaheadSearch = _useTypeaheadSearch2[1],
    resetTypeahead = _useTypeaheadSearch2[2];
  var handleOpen = function handleOpen(pointerEvent) {
    if (!isDisabled) {
      context.onOpenChange(true);
      resetTypeahead();
    }
    if (pointerEvent) {
      context.triggerPointerDownPosRef.current = {
        x: Math.round(pointerEvent.pageX),
        y: Math.round(pointerEvent.pageY)
      };
    }
  };
  return /* @__PURE__ */jsx(PopperPrimitive.Anchor, _objectSpread(_objectSpread({
    asChild: true
  }, popperScope), {}, {
    children: /* @__PURE__ */jsx(Primitive.button, _objectSpread(_objectSpread({
      type: "button",
      role: "combobox",
      "aria-controls": context.contentId,
      "aria-expanded": context.open,
      "aria-required": context.required,
      "aria-autocomplete": "none",
      dir: context.dir,
      "data-state": context.open ? "open" : "closed",
      disabled: isDisabled,
      "data-disabled": isDisabled ? "" : void 0,
      "data-placeholder": shouldShowPlaceholder(context.value) ? "" : void 0
    }, triggerProps), {}, {
      ref: composedRefs,
      onClick: composeEventHandlers(triggerProps.onClick, function (event) {
        event.currentTarget.focus();
        if (pointerTypeRef.current !== "mouse") {
          handleOpen(event);
        }
      }),
      onPointerDown: composeEventHandlers(triggerProps.onPointerDown, function (event) {
        pointerTypeRef.current = event.pointerType;
        var target = event.target;
        if (target.hasPointerCapture(event.pointerId)) {
          target.releasePointerCapture(event.pointerId);
        }
        if (event.button === 0 && event.ctrlKey === false && event.pointerType === "mouse") {
          handleOpen(event);
          event.preventDefault();
        }
      }),
      onKeyDown: composeEventHandlers(triggerProps.onKeyDown, function (event) {
        var isTypingAhead = searchRef.current !== "";
        var isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
        if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
        if (isTypingAhead && event.key === " ") return;
        if (OPEN_KEYS.includes(event.key)) {
          handleOpen();
          event.preventDefault();
        }
      })
    }))
  }));
});
SelectTrigger.displayName = TRIGGER_NAME;
var VALUE_NAME = "SelectValue";
var SelectValue = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    className = props.className,
    style = props.style,
    children = props.children,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? "" : _props$placeholder,
    valueProps = _objectWithoutProperties(props, _excluded2);
  var context = useSelectContext(VALUE_NAME, __scopeSelect);
  var onValueNodeHasChildrenChange = context.onValueNodeHasChildrenChange;
  var hasChildren = children !== void 0;
  var composedRefs = useComposedRefs(forwardedRef, context.onValueNodeChange);
  useLayoutEffect(function () {
    onValueNodeHasChildrenChange(hasChildren);
  }, [onValueNodeHasChildrenChange, hasChildren]);
  return /* @__PURE__ */jsx(Primitive.span, _objectSpread(_objectSpread({}, valueProps), {}, {
    ref: composedRefs,
    style: {
      pointerEvents: "none"
    },
    children: shouldShowPlaceholder(context.value) ? /* @__PURE__ */jsx(Fragment, {
      children: placeholder
    }) : children
  }));
});
SelectValue.displayName = VALUE_NAME;
var ICON_NAME = "SelectIcon";
var SelectIcon = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    children = props.children,
    iconProps = _objectWithoutProperties(props, _excluded3);
  return /* @__PURE__ */jsx(Primitive.span, _objectSpread(_objectSpread({
    "aria-hidden": true
  }, iconProps), {}, {
    ref: forwardedRef,
    children: children || "\u25BC"
  }));
});
SelectIcon.displayName = ICON_NAME;
var PORTAL_NAME = "SelectPortal";
var SelectPortal = function SelectPortal(props) {
  return /* @__PURE__ */jsx(PortalPrimitive, _objectSpread({
    asChild: true
  }, props));
};
SelectPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "SelectContent";
var SelectContent = React.forwardRef(function (props, forwardedRef) {
  var context = useSelectContext(CONTENT_NAME, props.__scopeSelect);
  var _React$useState9 = React.useState(),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    fragment = _React$useState0[0],
    setFragment = _React$useState0[1];
  useLayoutEffect(function () {
    setFragment(new DocumentFragment());
  }, []);
  if (!context.open) {
    var frag = fragment;
    return frag ? ReactDOM.createPortal(/* @__PURE__ */jsx(SelectContentProvider, {
      scope: props.__scopeSelect,
      children: /* @__PURE__ */jsx(Collection.Slot, {
        scope: props.__scopeSelect,
        children: /* @__PURE__ */jsx("div", {
          children: props.children
        })
      })
    }), frag) : null;
  }
  return /* @__PURE__ */jsx(SelectContentImpl, _objectSpread(_objectSpread({}, props), {}, {
    ref: forwardedRef
  }));
});
SelectContent.displayName = CONTENT_NAME;
var CONTENT_MARGIN = 10;
var _createSelectContext5 = createSelectContext(CONTENT_NAME),
  _createSelectContext6 = _slicedToArray(_createSelectContext5, 2),
  SelectContentProvider = _createSelectContext6[0],
  useSelectContentContext = _createSelectContext6[1];
var CONTENT_IMPL_NAME = "SelectContentImpl";
var Slot = createSlot("SelectContent.RemoveScroll");
var SelectContentImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    _props$position = props.position,
    position = _props$position === void 0 ? "item-aligned" : _props$position,
    onCloseAutoFocus = props.onCloseAutoFocus,
    onEscapeKeyDown = props.onEscapeKeyDown,
    onPointerDownOutside = props.onPointerDownOutside,
    side = props.side,
    sideOffset = props.sideOffset,
    align = props.align,
    alignOffset = props.alignOffset,
    arrowPadding = props.arrowPadding,
    collisionBoundary = props.collisionBoundary,
    collisionPadding = props.collisionPadding,
    sticky = props.sticky,
    hideWhenDetached = props.hideWhenDetached,
    avoidCollisions = props.avoidCollisions,
    contentProps = _objectWithoutProperties(props, _excluded4);
  var context = useSelectContext(CONTENT_NAME, __scopeSelect);
  var _React$useState1 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    content = _React$useState10[0],
    setContent = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    viewport = _React$useState12[0],
    setViewport = _React$useState12[1];
  var composedRefs = useComposedRefs(forwardedRef, function (node) {
    return setContent(node);
  });
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    selectedItem = _React$useState14[0],
    setSelectedItem = _React$useState14[1];
  var _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    selectedItemText = _React$useState16[0],
    setSelectedItemText = _React$useState16[1];
  var getItems = useCollection(__scopeSelect);
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isPositioned = _React$useState18[0],
    setIsPositioned = _React$useState18[1];
  var firstValidItemFoundRef = React.useRef(false);
  React.useEffect(function () {
    if (content) return hideOthers(content);
  }, [content]);
  useFocusGuards();
  var focusFirst = React.useCallback(function (candidates) {
    var _getItems$map = getItems().map(function (item) {
        return item.ref.current;
      }),
      _getItems$map2 = _toArray(_getItems$map),
      firstItem = _getItems$map2[0],
      restItems = _getItems$map2.slice(1);
    var _restItems$slice = restItems.slice(-1),
      _restItems$slice2 = _slicedToArray(_restItems$slice, 1),
      lastItem = _restItems$slice2[0];
    var PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    var _iterator = _createForOfIteratorHelper(candidates),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var candidate = _step.value;
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate === null || candidate === void 0 || candidate.scrollIntoView({
          block: "nearest"
        });
        if (candidate === firstItem && viewport) viewport.scrollTop = 0;
        if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
        candidate === null || candidate === void 0 || candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [getItems, viewport]);
  var focusSelectedItem = React.useCallback(function () {
    return focusFirst([selectedItem, content]);
  }, [focusFirst, selectedItem, content]);
  React.useEffect(function () {
    if (isPositioned) {
      focusSelectedItem();
    }
  }, [isPositioned, focusSelectedItem]);
  var onOpenChange = context.onOpenChange,
    triggerPointerDownPosRef = context.triggerPointerDownPosRef;
  React.useEffect(function () {
    if (content) {
      var pointerMoveDelta = {
        x: 0,
        y: 0
      };
      var handlePointerMove = function handlePointerMove(event) {
        var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
        pointerMoveDelta = {
          x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
          y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
        };
      };
      var handlePointerUp = function handlePointerUp(event) {
        if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) {
          event.preventDefault();
        } else {
          if (!content.contains(event.target)) {
            onOpenChange(false);
          }
        }
        document.removeEventListener("pointermove", handlePointerMove);
        triggerPointerDownPosRef.current = null;
      };
      if (triggerPointerDownPosRef.current !== null) {
        document.addEventListener("pointermove", handlePointerMove);
        document.addEventListener("pointerup", handlePointerUp, {
          capture: true,
          once: true
        });
      }
      return function () {
        document.removeEventListener("pointermove", handlePointerMove);
        document.removeEventListener("pointerup", handlePointerUp, {
          capture: true
        });
      };
    }
  }, [content, onOpenChange, triggerPointerDownPosRef]);
  React.useEffect(function () {
    var close = function close() {
      return onOpenChange(false);
    };
    window.addEventListener("blur", close);
    window.addEventListener("resize", close);
    return function () {
      window.removeEventListener("blur", close);
      window.removeEventListener("resize", close);
    };
  }, [onOpenChange]);
  var _useTypeaheadSearch3 = useTypeaheadSearch(function (search) {
      var enabledItems = getItems().filter(function (item) {
        return !item.disabled;
      });
      var currentItem = enabledItems.find(function (item) {
        return item.ref.current === document.activeElement;
      });
      var nextItem = findNextItem(enabledItems, search, currentItem);
      if (nextItem) {
        setTimeout(function () {
          return nextItem.ref.current.focus();
        });
      }
    }),
    _useTypeaheadSearch4 = _slicedToArray(_useTypeaheadSearch3, 2),
    searchRef = _useTypeaheadSearch4[0],
    handleTypeaheadSearch = _useTypeaheadSearch4[1];
  var itemRefCallback = React.useCallback(function (node, value, disabled) {
    var isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
    var isSelectedItem = context.value !== void 0 && context.value === value;
    if (isSelectedItem || isFirstValidItem) {
      setSelectedItem(node);
      if (isFirstValidItem) firstValidItemFoundRef.current = true;
    }
  }, [context.value]);
  var handleItemLeave = React.useCallback(function () {
    return content === null || content === void 0 ? void 0 : content.focus();
  }, [content]);
  var itemTextRefCallback = React.useCallback(function (node, value, disabled) {
    var isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
    var isSelectedItem = context.value !== void 0 && context.value === value;
    if (isSelectedItem || isFirstValidItem) {
      setSelectedItemText(node);
    }
  }, [context.value]);
  var SelectPosition = position === "popper" ? SelectPopperPosition : SelectItemAlignedPosition;
  var popperContentProps = SelectPosition === SelectPopperPosition ? {
    side: side,
    sideOffset: sideOffset,
    align: align,
    alignOffset: alignOffset,
    arrowPadding: arrowPadding,
    collisionBoundary: collisionBoundary,
    collisionPadding: collisionPadding,
    sticky: sticky,
    hideWhenDetached: hideWhenDetached,
    avoidCollisions: avoidCollisions
  } : {};
  return /* @__PURE__ */jsx(SelectContentProvider, {
    scope: __scopeSelect,
    content: content,
    viewport: viewport,
    onViewportChange: setViewport,
    itemRefCallback: itemRefCallback,
    selectedItem: selectedItem,
    onItemLeave: handleItemLeave,
    itemTextRefCallback: itemTextRefCallback,
    focusSelectedItem: focusSelectedItem,
    selectedItemText: selectedItemText,
    position: position,
    isPositioned: isPositioned,
    searchRef: searchRef,
    children: /* @__PURE__ */jsx(RemoveScroll, {
      as: Slot,
      allowPinchZoom: true,
      children: /* @__PURE__ */jsx(FocusScope, {
        asChild: true,
        trapped: context.open,
        onMountAutoFocus: function onMountAutoFocus(event) {
          event.preventDefault();
        },
        onUnmountAutoFocus: composeEventHandlers(onCloseAutoFocus, function (event) {
          var _context$trigger;
          (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
            preventScroll: true
          });
          event.preventDefault();
        }),
        children: /* @__PURE__ */jsx(DismissableLayer, {
          asChild: true,
          disableOutsidePointerEvents: true,
          onEscapeKeyDown: onEscapeKeyDown,
          onPointerDownOutside: onPointerDownOutside,
          onFocusOutside: function onFocusOutside(event) {
            return event.preventDefault();
          },
          onDismiss: function onDismiss() {
            return context.onOpenChange(false);
          },
          children: /* @__PURE__ */jsx(SelectPosition, _objectSpread(_objectSpread(_objectSpread({
            role: "listbox",
            id: context.contentId,
            "data-state": context.open ? "open" : "closed",
            dir: context.dir,
            onContextMenu: function onContextMenu(event) {
              return event.preventDefault();
            }
          }, contentProps), popperContentProps), {}, {
            onPlaced: function onPlaced() {
              return setIsPositioned(true);
            },
            ref: composedRefs,
            style: _objectSpread({
              // flex layout so we can place the scroll buttons properly
              display: "flex",
              flexDirection: "column",
              // reset the outline by default as the content MAY get focused
              outline: "none"
            }, contentProps.style),
            onKeyDown: composeEventHandlers(contentProps.onKeyDown, function (event) {
              var isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
              if (event.key === "Tab") event.preventDefault();
              if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
              if (["ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) {
                var items = getItems().filter(function (item) {
                  return !item.disabled;
                });
                var candidateNodes = items.map(function (item) {
                  return item.ref.current;
                });
                if (["ArrowUp", "End"].includes(event.key)) {
                  candidateNodes = candidateNodes.slice().reverse();
                }
                if (["ArrowUp", "ArrowDown"].includes(event.key)) {
                  var currentElement = event.target;
                  var currentIndex = candidateNodes.indexOf(currentElement);
                  candidateNodes = candidateNodes.slice(currentIndex + 1);
                }
                setTimeout(function () {
                  return focusFirst(candidateNodes);
                });
                event.preventDefault();
              }
            })
          }))
        })
      })
    })
  });
});
SelectContentImpl.displayName = CONTENT_IMPL_NAME;
var ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var SelectItemAlignedPosition = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    onPlaced = props.onPlaced,
    popperProps = _objectWithoutProperties(props, _excluded5);
  var context = useSelectContext(CONTENT_NAME, __scopeSelect);
  var contentContext = useSelectContentContext(CONTENT_NAME, __scopeSelect);
  var _React$useState19 = React.useState(null),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    contentWrapper = _React$useState20[0],
    setContentWrapper = _React$useState20[1];
  var _React$useState21 = React.useState(null),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    content = _React$useState22[0],
    setContent = _React$useState22[1];
  var composedRefs = useComposedRefs(forwardedRef, function (node) {
    return setContent(node);
  });
  var getItems = useCollection(__scopeSelect);
  var shouldExpandOnScrollRef = React.useRef(false);
  var shouldRepositionRef = React.useRef(true);
  var viewport = contentContext.viewport,
    selectedItem = contentContext.selectedItem,
    selectedItemText = contentContext.selectedItemText,
    focusSelectedItem = contentContext.focusSelectedItem;
  var position = React.useCallback(function () {
    if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
      var triggerRect = context.trigger.getBoundingClientRect();
      var contentRect = content.getBoundingClientRect();
      var valueNodeRect = context.valueNode.getBoundingClientRect();
      var itemTextRect = selectedItemText.getBoundingClientRect();
      if (context.dir !== "rtl") {
        var itemTextOffset = itemTextRect.left - contentRect.left;
        var left = valueNodeRect.left - itemTextOffset;
        var leftDelta = triggerRect.left - left;
        var minContentWidth = triggerRect.width + leftDelta;
        var contentWidth = Math.max(minContentWidth, contentRect.width);
        var rightEdge = window.innerWidth - CONTENT_MARGIN;
        var clampedLeft = clamp(left, [CONTENT_MARGIN,
        // Prevents the content from going off the starting edge of the
        // viewport. It may still go off the ending edge, but this can be
        // controlled by the user since they may want to manage overflow in a
        // specific way.
        // https://github.com/radix-ui/primitives/issues/2049
        Math.max(CONTENT_MARGIN, rightEdge - contentWidth)]);
        contentWrapper.style.minWidth = minContentWidth + "px";
        contentWrapper.style.left = clampedLeft + "px";
      } else {
        var _itemTextOffset = contentRect.right - itemTextRect.right;
        var right = window.innerWidth - valueNodeRect.right - _itemTextOffset;
        var rightDelta = window.innerWidth - triggerRect.right - right;
        var _minContentWidth = triggerRect.width + rightDelta;
        var _contentWidth = Math.max(_minContentWidth, contentRect.width);
        var leftEdge = window.innerWidth - CONTENT_MARGIN;
        var clampedRight = clamp(right, [CONTENT_MARGIN, Math.max(CONTENT_MARGIN, leftEdge - _contentWidth)]);
        contentWrapper.style.minWidth = _minContentWidth + "px";
        contentWrapper.style.right = clampedRight + "px";
      }
      var items = getItems();
      var availableHeight = window.innerHeight - CONTENT_MARGIN * 2;
      var itemsHeight = viewport.scrollHeight;
      var contentStyles = window.getComputedStyle(content);
      var contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
      var contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
      var contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
      var contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
      var fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
      var minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
      var viewportStyles = window.getComputedStyle(viewport);
      var viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
      var viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
      var topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - CONTENT_MARGIN;
      var triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
      var selectedItemHalfHeight = selectedItem.offsetHeight / 2;
      var itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
      var contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
      var itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
      var willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
      if (willAlignWithoutTopOverflow) {
        var isLastItem = items.length > 0 && selectedItem === items[items.length - 1].ref.current;
        contentWrapper.style.bottom = "0px";
        var viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
        var clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (
        // viewport might have padding bottom, include it to avoid a scrollable viewport
        isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
        var height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
        contentWrapper.style.height = height + "px";
      } else {
        var isFirstItem = items.length > 0 && selectedItem === items[0].ref.current;
        contentWrapper.style.top = "0px";
        var clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (
        // viewport might have padding top, include it to avoid a scrollable viewport
        isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
        var _height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
        contentWrapper.style.height = _height + "px";
        viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
      }
      contentWrapper.style.margin = "".concat(CONTENT_MARGIN, "px 0");
      contentWrapper.style.minHeight = minContentHeight + "px";
      contentWrapper.style.maxHeight = availableHeight + "px";
      onPlaced === null || onPlaced === void 0 || onPlaced();
      requestAnimationFrame(function () {
        return shouldExpandOnScrollRef.current = true;
      });
    }
  }, [getItems, context.trigger, context.valueNode, contentWrapper, content, viewport, selectedItem, selectedItemText, context.dir, onPlaced]);
  useLayoutEffect(function () {
    return position();
  }, [position]);
  var _React$useState23 = React.useState(),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    contentZIndex = _React$useState24[0],
    setContentZIndex = _React$useState24[1];
  useLayoutEffect(function () {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  var handleScrollButtonChange = React.useCallback(function (node) {
    if (node && shouldRepositionRef.current === true) {
      position();
      focusSelectedItem === null || focusSelectedItem === void 0 || focusSelectedItem();
      shouldRepositionRef.current = false;
    }
  }, [position, focusSelectedItem]);
  return /* @__PURE__ */jsx(SelectViewportProvider, {
    scope: __scopeSelect,
    contentWrapper: contentWrapper,
    shouldExpandOnScrollRef: shouldExpandOnScrollRef,
    onScrollButtonChange: handleScrollButtonChange,
    children: /* @__PURE__ */jsx("div", {
      ref: setContentWrapper,
      style: {
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        zIndex: contentZIndex
      },
      children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({}, popperProps), {}, {
        ref: composedRefs,
        style: _objectSpread({
          // When we get the height of the content, it includes borders. If we were to set
          // the height without having `boxSizing: 'border-box'` it would be too big.
          boxSizing: "border-box",
          // We need to ensure the content doesn't get taller than the wrapper
          maxHeight: "100%"
        }, popperProps.style)
      }))
    })
  });
});
SelectItemAlignedPosition.displayName = ITEM_ALIGNED_POSITION_NAME;
var POPPER_POSITION_NAME = "SelectPopperPosition";
var SelectPopperPosition = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    _props$align = props.align,
    align = _props$align === void 0 ? "start" : _props$align,
    _props$collisionPaddi = props.collisionPadding,
    collisionPadding = _props$collisionPaddi === void 0 ? CONTENT_MARGIN : _props$collisionPaddi,
    popperProps = _objectWithoutProperties(props, _excluded6);
  var popperScope = usePopperScope(__scopeSelect);
  return /* @__PURE__ */jsx(PopperPrimitive.Content, _objectSpread(_objectSpread(_objectSpread({}, popperScope), popperProps), {}, {
    ref: forwardedRef,
    align: align,
    collisionPadding: collisionPadding,
    style: _objectSpread(_objectSpread({
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box"
    }, popperProps.style), {
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    })
  }));
});
SelectPopperPosition.displayName = POPPER_POSITION_NAME;
var _createSelectContext7 = createSelectContext(CONTENT_NAME, {}),
  _createSelectContext8 = _slicedToArray(_createSelectContext7, 2),
  SelectViewportProvider = _createSelectContext8[0],
  useSelectViewportContext = _createSelectContext8[1];
var VIEWPORT_NAME = "SelectViewport";
var SelectViewport = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    nonce = props.nonce,
    viewportProps = _objectWithoutProperties(props, _excluded7);
  var contentContext = useSelectContentContext(VIEWPORT_NAME, __scopeSelect);
  var viewportContext = useSelectViewportContext(VIEWPORT_NAME, __scopeSelect);
  var composedRefs = useComposedRefs(forwardedRef, contentContext.onViewportChange);
  var prevScrollTopRef = React.useRef(0);
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("style", {
      dangerouslySetInnerHTML: {
        __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
      },
      nonce: nonce
    }), /* @__PURE__ */jsx(Collection.Slot, {
      scope: __scopeSelect,
      children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
        "data-radix-select-viewport": "",
        role: "presentation"
      }, viewportProps), {}, {
        ref: composedRefs,
        style: _objectSpread({
          // we use position: 'relative' here on the `viewport` so that when we call
          // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
          // (independent of the scrollUpButton).
          position: "relative",
          flex: 1,
          // Viewport should only be scrollable in the vertical direction.
          // This won't work in vertical writing modes, so we'll need to
          // revisit this if/when that is supported
          // https://developer.chrome.com/blog/vertical-form-controls
          overflow: "hidden auto"
        }, viewportProps.style),
        onScroll: composeEventHandlers(viewportProps.onScroll, function (event) {
          var viewport = event.currentTarget;
          var contentWrapper = viewportContext.contentWrapper,
            shouldExpandOnScrollRef = viewportContext.shouldExpandOnScrollRef;
          if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
            var scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
            if (scrolledBy > 0) {
              var availableHeight = window.innerHeight - CONTENT_MARGIN * 2;
              var cssMinHeight = parseFloat(contentWrapper.style.minHeight);
              var cssHeight = parseFloat(contentWrapper.style.height);
              var prevHeight = Math.max(cssMinHeight, cssHeight);
              if (prevHeight < availableHeight) {
                var nextHeight = prevHeight + scrolledBy;
                var clampedNextHeight = Math.min(availableHeight, nextHeight);
                var heightDiff = nextHeight - clampedNextHeight;
                contentWrapper.style.height = clampedNextHeight + "px";
                if (contentWrapper.style.bottom === "0px") {
                  viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                  contentWrapper.style.justifyContent = "flex-end";
                }
              }
            }
          }
          prevScrollTopRef.current = viewport.scrollTop;
        })
      }))
    })]
  });
});
SelectViewport.displayName = VIEWPORT_NAME;
var GROUP_NAME = "SelectGroup";
var _createSelectContext9 = createSelectContext(GROUP_NAME),
  _createSelectContext0 = _slicedToArray(_createSelectContext9, 2),
  SelectGroupContextProvider = _createSelectContext0[0],
  useSelectGroupContext = _createSelectContext0[1];
var SelectGroup = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    groupProps = _objectWithoutProperties(props, _excluded8);
  var groupId = useId();
  return /* @__PURE__ */jsx(SelectGroupContextProvider, {
    scope: __scopeSelect,
    id: groupId,
    children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
      role: "group",
      "aria-labelledby": groupId
    }, groupProps), {}, {
      ref: forwardedRef
    }))
  });
});
SelectGroup.displayName = GROUP_NAME;
var LABEL_NAME = "SelectLabel";
var SelectLabel = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    labelProps = _objectWithoutProperties(props, _excluded9);
  var groupContext = useSelectGroupContext(LABEL_NAME, __scopeSelect);
  return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
    id: groupContext.id
  }, labelProps), {}, {
    ref: forwardedRef
  }));
});
SelectLabel.displayName = LABEL_NAME;
var ITEM_NAME = "SelectItem";
var _createSelectContext1 = createSelectContext(ITEM_NAME),
  _createSelectContext10 = _slicedToArray(_createSelectContext1, 2),
  SelectItemContextProvider = _createSelectContext10[0],
  useSelectItemContext = _createSelectContext10[1];
var SelectItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    value = props.value,
    _props$disabled2 = props.disabled,
    disabled = _props$disabled2 === void 0 ? false : _props$disabled2,
    textValueProp = props.textValue,
    itemProps = _objectWithoutProperties(props, _excluded0);
  var context = useSelectContext(ITEM_NAME, __scopeSelect);
  var contentContext = useSelectContentContext(ITEM_NAME, __scopeSelect);
  var isSelected = context.value === value;
  var _React$useState25 = React.useState(textValueProp !== null && textValueProp !== void 0 ? textValueProp : ""),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    textValue = _React$useState26[0],
    setTextValue = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isFocused = _React$useState28[0],
    setIsFocused = _React$useState28[1];
  var composedRefs = useComposedRefs(forwardedRef, function (node) {
    var _contentContext$itemR;
    return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node, value, disabled);
  });
  var textId = useId();
  var pointerTypeRef = React.useRef("touch");
  var handleSelect = function handleSelect() {
    if (!disabled) {
      context.onValueChange(value);
      context.onOpenChange(false);
    }
  };
  if (value === "") {
    throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
  }
  return /* @__PURE__ */jsx(SelectItemContextProvider, {
    scope: __scopeSelect,
    value: value,
    disabled: disabled,
    textId: textId,
    isSelected: isSelected,
    onItemTextChange: React.useCallback(function (node) {
      setTextValue(function (prevTextValue) {
        var _node$textContent;
        return prevTextValue || ((_node$textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : "").trim();
      });
    }, []),
    children: /* @__PURE__ */jsx(Collection.ItemSlot, {
      scope: __scopeSelect,
      value: value,
      disabled: disabled,
      textValue: textValue,
      children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
        role: "option",
        "aria-labelledby": textId,
        "data-highlighted": isFocused ? "" : void 0,
        "aria-selected": isSelected && isFocused,
        "data-state": isSelected ? "checked" : "unchecked",
        "aria-disabled": disabled || void 0,
        "data-disabled": disabled ? "" : void 0,
        tabIndex: disabled ? void 0 : -1
      }, itemProps), {}, {
        ref: composedRefs,
        onFocus: composeEventHandlers(itemProps.onFocus, function () {
          return setIsFocused(true);
        }),
        onBlur: composeEventHandlers(itemProps.onBlur, function () {
          return setIsFocused(false);
        }),
        onClick: composeEventHandlers(itemProps.onClick, function () {
          if (pointerTypeRef.current !== "mouse") handleSelect();
        }),
        onPointerUp: composeEventHandlers(itemProps.onPointerUp, function () {
          if (pointerTypeRef.current === "mouse") handleSelect();
        }),
        onPointerDown: composeEventHandlers(itemProps.onPointerDown, function (event) {
          pointerTypeRef.current = event.pointerType;
        }),
        onPointerMove: composeEventHandlers(itemProps.onPointerMove, function (event) {
          pointerTypeRef.current = event.pointerType;
          if (disabled) {
            var _contentContext$onIte;
            (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
          } else if (pointerTypeRef.current === "mouse") {
            event.currentTarget.focus({
              preventScroll: true
            });
          }
        }),
        onPointerLeave: composeEventHandlers(itemProps.onPointerLeave, function (event) {
          if (event.currentTarget === document.activeElement) {
            var _contentContext$onIte2;
            (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
          }
        }),
        onKeyDown: composeEventHandlers(itemProps.onKeyDown, function (event) {
          var _contentContext$searc;
          var isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== "";
          if (isTypingAhead && event.key === " ") return;
          if (SELECTION_KEYS.includes(event.key)) handleSelect();
          if (event.key === " ") event.preventDefault();
        })
      }))
    })
  });
});
SelectItem.displayName = ITEM_NAME;
var ITEM_TEXT_NAME = "SelectItemText";
var SelectItemText = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    className = props.className,
    style = props.style,
    itemTextProps = _objectWithoutProperties(props, _excluded1);
  var context = useSelectContext(ITEM_TEXT_NAME, __scopeSelect);
  var contentContext = useSelectContentContext(ITEM_TEXT_NAME, __scopeSelect);
  var itemContext = useSelectItemContext(ITEM_TEXT_NAME, __scopeSelect);
  var nativeOptionsContext = useSelectNativeOptionsContext(ITEM_TEXT_NAME, __scopeSelect);
  var _React$useState29 = React.useState(null),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    itemTextNode = _React$useState30[0],
    setItemTextNode = _React$useState30[1];
  var composedRefs = useComposedRefs(forwardedRef, function (node) {
    return setItemTextNode(node);
  }, itemContext.onItemTextChange, function (node) {
    var _contentContext$itemT;
    return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node, itemContext.value, itemContext.disabled);
  });
  var textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
  var nativeOption = React.useMemo(function () {
    return /* @__PURE__ */jsx("option", {
      value: itemContext.value,
      disabled: itemContext.disabled,
      children: textContent
    }, itemContext.value);
  }, [itemContext.disabled, itemContext.value, textContent]);
  var onNativeOptionAdd = nativeOptionsContext.onNativeOptionAdd,
    onNativeOptionRemove = nativeOptionsContext.onNativeOptionRemove;
  useLayoutEffect(function () {
    onNativeOptionAdd(nativeOption);
    return function () {
      return onNativeOptionRemove(nativeOption);
    };
  }, [onNativeOptionAdd, onNativeOptionRemove, nativeOption]);
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(Primitive.span, _objectSpread(_objectSpread({
      id: itemContext.textId
    }, itemTextProps), {}, {
      ref: composedRefs
    })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? ReactDOM.createPortal(itemTextProps.children, context.valueNode) : null]
  });
});
SelectItemText.displayName = ITEM_TEXT_NAME;
var ITEM_INDICATOR_NAME = "SelectItemIndicator";
var SelectItemIndicator = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    itemIndicatorProps = _objectWithoutProperties(props, _excluded10);
  var itemContext = useSelectItemContext(ITEM_INDICATOR_NAME, __scopeSelect);
  return itemContext.isSelected ? /* @__PURE__ */jsx(Primitive.span, _objectSpread(_objectSpread({
    "aria-hidden": true
  }, itemIndicatorProps), {}, {
    ref: forwardedRef
  })) : null;
});
SelectItemIndicator.displayName = ITEM_INDICATOR_NAME;
var SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var SelectScrollUpButton = React.forwardRef(function (props, forwardedRef) {
  var contentContext = useSelectContentContext(SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
  var viewportContext = useSelectViewportContext(SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    canScrollUp = _React$useState32[0],
    setCanScrollUp = _React$useState32[1];
  var composedRefs = useComposedRefs(forwardedRef, viewportContext.onScrollButtonChange);
  useLayoutEffect(function () {
    if (contentContext.viewport && contentContext.isPositioned) {
      var handleScroll2 = function handleScroll2() {
        var canScrollUp2 = viewport.scrollTop > 0;
        setCanScrollUp(canScrollUp2);
      };
      var handleScroll = handleScroll2;
      var viewport = contentContext.viewport;
      handleScroll2();
      viewport.addEventListener("scroll", handleScroll2);
      return function () {
        return viewport.removeEventListener("scroll", handleScroll2);
      };
    }
  }, [contentContext.viewport, contentContext.isPositioned]);
  return canScrollUp ? /* @__PURE__ */jsx(SelectScrollButtonImpl, _objectSpread(_objectSpread({}, props), {}, {
    ref: composedRefs,
    onAutoScroll: function onAutoScroll() {
      var viewport = contentContext.viewport,
        selectedItem = contentContext.selectedItem;
      if (viewport && selectedItem) {
        viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
      }
    }
  })) : null;
});
SelectScrollUpButton.displayName = SCROLL_UP_BUTTON_NAME;
var SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var SelectScrollDownButton = React.forwardRef(function (props, forwardedRef) {
  var contentContext = useSelectContentContext(SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
  var viewportContext = useSelectViewportContext(SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
  var _React$useState33 = React.useState(false),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    canScrollDown = _React$useState34[0],
    setCanScrollDown = _React$useState34[1];
  var composedRefs = useComposedRefs(forwardedRef, viewportContext.onScrollButtonChange);
  useLayoutEffect(function () {
    if (contentContext.viewport && contentContext.isPositioned) {
      var handleScroll2 = function handleScroll2() {
        var maxScroll = viewport.scrollHeight - viewport.clientHeight;
        var canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
        setCanScrollDown(canScrollDown2);
      };
      var handleScroll = handleScroll2;
      var viewport = contentContext.viewport;
      handleScroll2();
      viewport.addEventListener("scroll", handleScroll2);
      return function () {
        return viewport.removeEventListener("scroll", handleScroll2);
      };
    }
  }, [contentContext.viewport, contentContext.isPositioned]);
  return canScrollDown ? /* @__PURE__ */jsx(SelectScrollButtonImpl, _objectSpread(_objectSpread({}, props), {}, {
    ref: composedRefs,
    onAutoScroll: function onAutoScroll() {
      var viewport = contentContext.viewport,
        selectedItem = contentContext.selectedItem;
      if (viewport && selectedItem) {
        viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
      }
    }
  })) : null;
});
SelectScrollDownButton.displayName = SCROLL_DOWN_BUTTON_NAME;
var SelectScrollButtonImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    onAutoScroll = props.onAutoScroll,
    scrollIndicatorProps = _objectWithoutProperties(props, _excluded11);
  var contentContext = useSelectContentContext("SelectScrollButton", __scopeSelect);
  var autoScrollTimerRef = React.useRef(null);
  var getItems = useCollection(__scopeSelect);
  var clearAutoScrollTimer = React.useCallback(function () {
    if (autoScrollTimerRef.current !== null) {
      window.clearInterval(autoScrollTimerRef.current);
      autoScrollTimerRef.current = null;
    }
  }, []);
  React.useEffect(function () {
    return function () {
      return clearAutoScrollTimer();
    };
  }, [clearAutoScrollTimer]);
  useLayoutEffect(function () {
    var _activeItem$ref$curre;
    var activeItem = getItems().find(function (item) {
      return item.ref.current === document.activeElement;
    });
    activeItem === null || activeItem === void 0 || (_activeItem$ref$curre = activeItem.ref.current) === null || _activeItem$ref$curre === void 0 || _activeItem$ref$curre.scrollIntoView({
      block: "nearest"
    });
  }, [getItems]);
  return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
    "aria-hidden": true
  }, scrollIndicatorProps), {}, {
    ref: forwardedRef,
    style: _objectSpread({
      flexShrink: 0
    }, scrollIndicatorProps.style),
    onPointerDown: composeEventHandlers(scrollIndicatorProps.onPointerDown, function () {
      if (autoScrollTimerRef.current === null) {
        autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
      }
    }),
    onPointerMove: composeEventHandlers(scrollIndicatorProps.onPointerMove, function () {
      var _contentContext$onIte3;
      (_contentContext$onIte3 = contentContext.onItemLeave) === null || _contentContext$onIte3 === void 0 || _contentContext$onIte3.call(contentContext);
      if (autoScrollTimerRef.current === null) {
        autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
      }
    }),
    onPointerLeave: composeEventHandlers(scrollIndicatorProps.onPointerLeave, function () {
      clearAutoScrollTimer();
    })
  }));
});
var SEPARATOR_NAME = "SelectSeparator";
var SelectSeparator = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    separatorProps = _objectWithoutProperties(props, _excluded12);
  return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
    "aria-hidden": true
  }, separatorProps), {}, {
    ref: forwardedRef
  }));
});
SelectSeparator.displayName = SEPARATOR_NAME;
var ARROW_NAME = "SelectArrow";
var SelectArrow = React.forwardRef(function (props, forwardedRef) {
  var __scopeSelect = props.__scopeSelect,
    arrowProps = _objectWithoutProperties(props, _excluded13);
  var popperScope = usePopperScope(__scopeSelect);
  var context = useSelectContext(ARROW_NAME, __scopeSelect);
  var contentContext = useSelectContentContext(ARROW_NAME, __scopeSelect);
  return context.open && contentContext.position === "popper" ? /* @__PURE__ */jsx(PopperPrimitive.Arrow, _objectSpread(_objectSpread(_objectSpread({}, popperScope), arrowProps), {}, {
    ref: forwardedRef
  })) : null;
});
SelectArrow.displayName = ARROW_NAME;
var BUBBLE_INPUT_NAME = "SelectBubbleInput";
var SelectBubbleInput = React.forwardRef(function (_ref, forwardedRef) {
  var __scopeSelect = _ref.__scopeSelect,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded14);
  var ref = React.useRef(null);
  var composedRefs = useComposedRefs(forwardedRef, ref);
  var prevValue = usePrevious(value);
  React.useEffect(function () {
    var select = ref.current;
    if (!select) return;
    var selectProto = window.HTMLSelectElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
    var setValue = descriptor.set;
    if (prevValue !== value && setValue) {
      var event = new Event("change", {
        bubbles: true
      });
      setValue.call(select, value);
      select.dispatchEvent(event);
    }
  }, [prevValue, value]);
  return /* @__PURE__ */jsx(Primitive.select, _objectSpread(_objectSpread({}, props), {}, {
    style: _objectSpread(_objectSpread({}, VISUALLY_HIDDEN_STYLES), props.style),
    ref: composedRefs,
    defaultValue: value
  }));
});
SelectBubbleInput.displayName = BUBBLE_INPUT_NAME;
function shouldShowPlaceholder(value) {
  return value === "" || value === void 0;
}
function useTypeaheadSearch(onSearchChange) {
  var handleSearchChange = useCallbackRef(onSearchChange);
  var searchRef = React.useRef("");
  var timerRef = React.useRef(0);
  var handleTypeaheadSearch = React.useCallback(function (key) {
    var search = searchRef.current + key;
    handleSearchChange(search);
    (function updateSearch(value) {
      searchRef.current = value;
      window.clearTimeout(timerRef.current);
      if (value !== "") timerRef.current = window.setTimeout(function () {
        return updateSearch("");
      }, 1e3);
    })(search);
  }, [handleSearchChange]);
  var resetTypeahead = React.useCallback(function () {
    searchRef.current = "";
    window.clearTimeout(timerRef.current);
  }, []);
  React.useEffect(function () {
    return function () {
      return window.clearTimeout(timerRef.current);
    };
  }, []);
  return [searchRef, handleTypeaheadSearch, resetTypeahead];
}
function findNextItem(items, search, currentItem) {
  var isRepeated = search.length > 1 && Array.from(search).every(function (char) {
    return char === search[0];
  });
  var normalizedSearch = isRepeated ? search[0] : search;
  var currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
  var wrappedItems = wrapArray(items, Math.max(currentItemIndex, 0));
  var excludeCurrentItem = normalizedSearch.length === 1;
  if (excludeCurrentItem) wrappedItems = wrappedItems.filter(function (v) {
    return v !== currentItem;
  });
  var nextItem = wrappedItems.find(function (item) {
    return item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase());
  });
  return nextItem !== currentItem ? nextItem : void 0;
}
function wrapArray(array, startIndex) {
  return array.map(function (_, index) {
    return array[(startIndex + index) % array.length];
  });
}
var Root2 = Select;
var Trigger = SelectTrigger;
var Value = SelectValue;
var Icon = SelectIcon;
var Portal = SelectPortal;
var Content2 = SelectContent;
var Viewport = SelectViewport;
var Group = SelectGroup;
var Label = SelectLabel;
var Item = SelectItem;
var ItemText = SelectItemText;
var ItemIndicator = SelectItemIndicator;
var ScrollUpButton = SelectScrollUpButton;
var ScrollDownButton = SelectScrollDownButton;
var Separator = SelectSeparator;
var Arrow2 = SelectArrow;
export { Arrow2 as Arrow, Content2 as Content, Group, Icon, Item, ItemIndicator, ItemText, Label, Portal, Root2 as Root, ScrollDownButton, ScrollUpButton, Select, SelectArrow, SelectContent, SelectGroup, SelectIcon, SelectItem, SelectItemIndicator, SelectItemText, SelectLabel, SelectPortal, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, SelectTrigger, SelectValue, SelectViewport, Separator, Trigger, Value, Viewport, createSelectScope };